module.exports = __webpack_public_path__ + "static/media/linkedin.d46a986b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/linkedin.png
// module id = 78
// module chunks = 0